<template>
  <v-flex xs12 sm10 md6 xl4>
    <div class="vertical-center-container">
      <v-select
        label="Select action"
        :items="actions"
        v-model="selectedAction"
        item-value="value"
        return-object
        prepend-inner-icon="list"
        clearable
        :clear-icon-cb="clearAction"
        :color="$store.state.global.pages.allocation.color"
      >
        <template slot="selection" slot-scope="data">
          {{
          !!selectedCount ? data.item.text == 'Match / Close Allocations' ? data.item.text : `${data.item.text} for ${selectedCount} Allocation${selectedCount > 1 ? 's' : ''}`
          : data.item.text
          }}
        </template>
      </v-select>
      <div>
        <v-btn
          :color="$store.state.global.pages[this.$route.name].color"
          flat
          @click="confirmAction()"
        >Confirm</v-btn>
      </div>
    </div>

    <!-- EXPORT CSV DIALOG CONFIRMATION -->
    <v-dialog
      v-model="exportAllocationsDialog"
      max-width="400px"
      @keydown.esc="exportAllocationsDialog = false"
      lazy
    >
      <v-card>
        <v-card-title class="headline">
          <span>
            Export selected documents?
            <span class="grey--text subheading"></span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="exportAllocationsDialog = false">Cancel</v-btn>
          <download-excel :fetch="allocationLines" type="csv" name="allocation.csv">
            <v-btn
              :color="primaryNeutral"
              flat
              @click="exportAllocationsDialog = false"
              :loading="loading"
            >Export Allocations</v-btn>
          </download-excel>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG CONFIRMATION -->
    <v-dialog
      v-model="matchConfirmDialog"
      max-width="700px"
      @keydown.esc="matchConfirmDialog = false"
      lazy
    >
      <v-card>
        <v-card-title class="headline">
          <layout-no-padding>
            <v-flex xs12>
              <span>
                Close any matching allocations?
                <span class="grey--text subheading"></span>
              </span>
            </v-flex>
          </layout-no-padding>
        </v-card-title>
        <v-form @submit.prevent="matchDockets()">
          <v-card-actions text-xs-right>
            <v-btn color="grey darken-1" flat @click="matchConfirmDialog = false">No</v-btn>
            <v-btn color="green darken-1" flat type="submit" :loading="loading">Yes</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import AllocationService from "@/services/requests/allocationService";
import BuildAllocationQuery from "@/services/mixins/buildAllocationQuery";
import DownloadExcel from "vue-json-excel";
import FormatDates from "@/services/mixins/formatDates";
export default {
  mixins: [BuildAllocationQuery, FormatDates],
  data() {
    return {
      actions: [
        {
          text: "Export Selected (CSV)",
          icon: "import_export",
          color: "grey",
          value: { value: null, text: "Export Selected (CSV)", label: "export" }
        },
        ...!!this.$store.state.user.userAuthClass.allocationWrite ? [{
          text: "Match / Close Allocations",
          icon: "",
          color: "$store.state.global.pages.allocation.color",
          value: {
            value: null,
            text: "Match / Close Allocations",
            label: "match"
          }
        }] : []
      ],
      selectedAction: {},
      loading: false,
      exportAllocationsDialog: false,
      matchConfirmDialog: false
    };
  },
  methods: {
    clearAction() {
      this.selectedAction = {};
    },
    confirmAction() {
      if (this.selectedAction.text == "Export Selected (CSV)") {
        return this.confirmExportAction();
      } else if (this.selectedAction.text == "Match / Close Allocations") {
        return this.confirmMatchAction();
      } else {
        console.log("Select Action");
      }
    },
    confirmExportAction() {
      if (!this.selectedCount) {
        this.snack({ color: "yellow", text: "No batches are selected!" });
        this.exportAllocationsDialog = false;
        return;
      }
      if (!Object.keys(this.selectedAction).length) {
        this.snack({ color: "yellow", text: "No action was selected!" });
        this.exportAllocationsDialog = false;
        return;
      } else {
        this.exportAllocationsDialog = true;
      }
    },
    confirmMatchAction() {
      if (!Object.keys(this.selectedAction).length) {
        this.snack({ color: "yellow", text: "No action was selected!" });
        this.matchConfirmDialog = false;
        return;
      } else {
        this.matchConfirmDialog = true;
      }
    },
    async retrieveLines() {
      var payload = this.buildQuery();
      payload.pagination = this.pagination;
      payload.csv = true;
      this.loading = true;
      try {
        var result = await AllocationService.getAllocations(payload);
        return result.data.result;
      } catch (err) {
        return [];
      }
    },
    async allocationLines() {
      var lines = await this.getAllocationLines();
      console.log("Allocations:", lines);
      lines = lines.map(line => {
        return {
          Date: line.date,
          Site: line.site.name,
          Spoil: line.spoil.name,
          Details: line.details,
          TipName: line.tip.name,
          TipTSE: line.tip.number,
          Vehicle: line.vehicle.name,
          Driver: line.driver.name,
          SubContractor: line.vehicle.contractor.name
        };
      });
      this.loading = false;
      return lines;
    },
    async getAllocationLines() {
      if (this.selectedAll) {
        return await this.retrieveLines();
      } else {
        try {
          var result = await AllocationService.getAllocationsByIds({
            ids: this.selected.map(allocation => allocation.id)
          });
          return result.data.result;
        } catch (err) {}
      }
    },
    matchDockets() {
      this.loading = true;
      AllocationService.matchDockets()
        .then(res => {
          this.fetchAllocations = true;
          this.loading = false;
          this.matchConfirmDialog = false;
          this.snack({ text: res.data.message, color: "green" });
        })
        .catch(err => {
          this.snackError();
          console.log(err);
          this.loading = false;
        });
    }
  },
  computed: {
    fetchAllocations: Store.getSet({
      store: "allocations",
      prop: "fetchAllocations"
    })
    // actionLabel() {
    //     return !!this.selectedCount
    //         ? this.selectedAction.text == 'Match / Close Allocations' ? this.selectedAction.text : `${this.selectedAction.text} for ${this.selectedCount} allocations`
    //         : `${this.selectedAction.text}`
    // }
  },
  props: {
    selected: Array,
    selectedCount: Number,
    selectedAll: Boolean,
    pagination: Object
  },
  components: {
    DownloadExcel
  }
};
</script>
